import { ResizeObserver } from '@juggle/resize-observer'
import React, { useEffect, useRef } from 'react'

export default function Resize({
  children,
  onChange,
}: {
  children: React.ReactNode
  onChange: (size: { height: number; width: number }) => void
}) {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    checkHeight()
    if (ref.current) {
      const resizeObserver: ResizeObserver = new ResizeObserver(checkHeight)
      resizeObserver.observe(ref.current)
      return () => {
        resizeObserver.disconnect()
      }
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const checkHeight = () => {
    if (ref.current) onChange({ height: ref.current.clientHeight, width: ref.current.clientWidth })
  }

  return <div ref={ref}>{children}</div>
}
